import { MainActionTypes } from "./mainReducer";
 

export const setProduct = (payload:any): any => {
  return {
    type: MainActionTypes.SET_PRODUCT,
    payload
  };
};
